import * as React from 'react';
import { useEffect } from 'react';
import styled from '@emotion/styled';
import { PackMember, PackModel } from '../../../../core/models/PackModel';
import { ProfileListItemWidget } from '../../../../widgets/controls/list/ProfileListItemWidget';
import { observer } from 'mobx-react';
import { AnimatedCollection, AnimatedCollectionType } from '../../../../widgets/collection/AnimatedCollection';
import { AppLink } from '../../../../widgets/utils';
import { GroupProfileRole } from '@foxbun/lib-goferal-types';
import { ButtonWidget } from '../../../../widgets/controls/ButtonWidget';
import { generatePath, useNavigate } from 'react-router-dom';
import { Routing } from '../../../Routing';

export interface PackMembersWidgetProps {
  pack: PackModel;
  className?: any;
}

export const PackMembersWidget: React.FC<PackMembersWidgetProps> = observer((props) => {
  useEffect(() => {
    props.pack.loadMembers();
  }, []);

  let can_invite = props.pack.my_status?.role === GroupProfileRole.OWNER;
  const navigate = useNavigate();

  return (
    <S.Container className={props.className}>
      <AnimatedCollection<PackMember>
        type={AnimatedCollectionType.SLIDE_IN_LEFT}
        children={props.pack.members}
        generate_inner={(p) => {
          return (
            <AppLink to={p.member.link} push={true}>
              <ProfileListItemWidget key={p.member.id.toString()} profile={p.member} meta={[{ label: p.role }]} />
            </AppLink>
          );
        }}
      />
      {can_invite ? (
        <ButtonWidget
          label="Invite member"
          action={() => {
            navigate(generatePath(Routing.PACK_INVITE_MEMBER, { id: props.pack.id.toString() }), { state: 'push' });
          }}
        />
      ) : null}
    </S.Container>
  );
});
namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 5px;
  `;
}
